import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as validationHelper from "../../../../../helpers/validationHelper";
import * as barcodeActions from "../../../../../actions/barcodeActions";
import * as itemTypes from "../../../../../constants/itemTypes";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as getterHelper from "../../../../../helpers/getterHelper";

import NumericKeyboardInput from "../../../../global/NumericKeyboardInput";
import Table, {TABLE_VARIANT_SECONDARY} from "../../../../global/generic/Table";
import Button from "../../../../global/generic/Button";
import Modal from "../../../../global/generic/Modal";
import CloseButton from "../../../../global/generic/CloseButton";

class AddColorantPackagesToStockModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedColorantPackageKey: this.props.params.selectedColorantPackageKey,
            amountToAdd: 1,
            colorantPackagesToAdd: [],
            flashingKey: "",
            addOrder: []
        };
    }

    componentDidUpdate() {
        if (this.props.barcodeType === itemTypes.COLORANT_PACKAGE) {
            const key = getterHelper.getStockItemKey(this.props.barcodeType, this.props.barcode);

            let colorantPackage = this.state.colorantPackagesToAdd.find(
                (colorantPackage) => colorantPackage.key === key
            );

            if (colorantPackage) {
                colorantPackage.value += 1;
            } else {
                this.state.colorantPackagesToAdd.push(
                    modelHelper.buildColorantPackageStock(
                        key,
                        this.props.barcode.name,
                        this.props.barcode.colorantName,
                        "",
                        1
                    )
                );
            }

            this.props.dispatchResetBarcodeAction();

            let addOrder = this.state.addOrder.filter((k) => k !== key);
            addOrder.unshift(key);

            this.setState({
                colorantPackagesToAdd: this.state.colorantPackagesToAdd,
                flashingKey: key,
                addOrder: addOrder
            });
        }
    }

    onAnimationEnd = () => {
        this.setState({
            flashingKey: ""
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseAddColorantPackagesToStockModalAction();
    };

    handleSubmit = () => {
        this.props.params.addColorantPackagesToStock(this.state.colorantPackagesToAdd);
    };

    handleFocus = (event) => {
        event.target.select();
    };

    handleAmountToAddChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                amountToAdd: Number(event.target.value)
            });
        }
    };

    setAmountToAddState = (value) => {
        if (validationHelper.isDecimalValueValid(value)) {
            this.setState({
                amountToAdd: Number(value)
            });
        }
    };

    handleAmountToAddBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= 0) {
            this.setState({amountToAdd: Number(value)});
        } else {
            this.setState({amountToAdd: 0});
        }
    };

    handleAmountChange = (colorantPackageKey, amount) => {
        let colorantPackagesToAdd = this.state.colorantPackagesToAdd;

        if (amount === -1) {
            colorantPackagesToAdd = colorantPackagesToAdd.filter(
                (colorantPackage) => colorantPackage.key !== colorantPackageKey
            );

            this.setState({
                colorantPackagesToAdd: colorantPackagesToAdd,
                addOrder: this.state.addOrder.filter((key) => key !== colorantPackageKey)
            });
        } else {
            const colorantPackage = colorantPackagesToAdd.find(
                (colorantPackage) => colorantPackage.key === colorantPackageKey
            );
            if (colorantPackage) {
                colorantPackage.value = amount;
            }

            this.setState({
                colorantPackagesToAdd: colorantPackagesToAdd
            });
        }
    };

    handleColorantPackageSelectChange = (event) => {
        this.setState({
            selectedColorantPackageKey: event.target.value
        });
    };

    handleAddColorantPackageClick = () => {
        const colorantPackagesToAdd = this.state.colorantPackagesToAdd;

        const colorantPackage = colorantPackagesToAdd.find(
            (colorantPackage) => colorantPackage.key === this.state.selectedColorantPackageKey
        );
        if (colorantPackage) {
            colorantPackage.value += this.state.amountToAdd;
        } else {
            const colorantPackageOriginal = this.props.colorantPackages.find(
                (colorantPackage) => colorantPackage.key === this.state.selectedColorantPackageKey
            );

            if (!colorantPackageOriginal) {
                return;
            }

            colorantPackagesToAdd.push(
                modelHelper.buildColorantPackageStock(
                    colorantPackageOriginal.key,
                    colorantPackageOriginal.item.package.name,
                    colorantPackageOriginal.item.colorant.name,
                    colorantPackageOriginal.database,
                    this.state.amountToAdd
                )
            );
        }

        let addOrder = this.state.addOrder.filter((key) => key !== this.state.selectedColorantPackageKey);
        addOrder.unshift(this.state.selectedColorantPackageKey);

        this.setState({
            colorantPackagesToAdd: colorantPackagesToAdd,
            flashingKey: this.state.selectedColorantPackageKey,
            addOrder: addOrder
        });
    };

    getAddColorantPackageLine = () => {
        return (
            <div className="flex padding-05em background-light-blue margin-bottom-10 font-size-2rem">
                <select
                    className="col-5 primary-select font-size-2rem"
                    style={{height: "unset"}}
                    onChange={this.handleColorantPackageSelectChange}
                    value={this.state.selectedColorantPackageKey}
                >
                    <option value={0}>{translate("stock.addColorant")}...</option>
                    {this.props.colorantPackages
                        .sort((a, b) => {
                            if (a.item.colorant.displayName < b.item.colorant.displayName) {
                                return -1;
                            }
                            if (a.item.colorant.displayName > b.item.colorant.displayName) {
                                return 1;
                            }
                            return 0;
                        })
                        .map((colorantPackage) => (
                            <option key={colorantPackage.key} value={colorantPackage.key}>
                                {colorantPackage.item.colorant.displayName}
                            </option>
                        ))}
                </select>
                <div className="col-3 margin-left-10 vertical-center text-center">
                    {this.state.selectedColorantPackageKey === ""
                        ? ""
                        : this.props.colorantPackages.find(
                              (colorantPackage) => colorantPackage.key === this.state.selectedColorantPackageKey
                          )?.item.package.displayName}
                </div>
                <div className="col-2 margin-left-10">
                    <NumericKeyboardInput
                        type="text"
                        value={this.state.amountToAdd}
                        onFocus={this.handleFocus}
                        onChange={this.handleAmountToAddChange}
                        onBlur={this.handleAmountToAddBlur}
                        disabled={false}
                        extended={false}
                        setInputState={this.setAmountToAddState}
                        className={"width-100per height-100per text-center general-input primary-input"}
                    />
                </div>
                <Button
                    className="margin-left-10 min-width-150 col-2 flex-align-center"
                    label={<Translate value="general.add" />}
                    onClick={this.handleAddColorantPackageClick}
                    disabled={this.state.selectedColorantPackageKey === "" || this.state.amountToAdd < 1}
                />
            </div>
        );
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.colorant" />),
            modelHelper.buildTableCell(<Translate value="general.package" />),
            modelHelper.buildTableCell(<Translate value="general.amount" />)
        ]);
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-7 vertical-center"),
            modelHelper.buildTableColumn("col-3 vertical-center text-center"),
            modelHelper.buildTableColumn("col-2 text-center")
        ];
    };

    getTableRows = () => {
        return this.state.addOrder.map((colorantPackageKey) => {
            const colorantPackage = this.state.colorantPackagesToAdd.find((colorantPackage) => {
                return colorantPackage.key === colorantPackageKey;
            });
            return modelHelper.buildTableRow(
                [
                    modelHelper.buildTableCell(
                        <span>
                            {colorantPackage.colorant}{" "}
                            <span className="color-secondary font-0_75em">({colorantPackage.database})</span>
                        </span>
                    ),
                    modelHelper.buildTableCell(colorantPackage.package),
                    modelHelper.buildTableCell(
                        <NumericKeyboardInput
                            type="text"
                            value={colorantPackage.value}
                            onFocus={this.handleFocus}
                            onChange={(event) => {
                                if (validationHelper.isDecimalValueValid(event.target.value)) {
                                    this.handleAmountChange(colorantPackage.key, Number(event.target.value));
                                }
                            }}
                            onBlur={(event) => {
                                let value = Number(event.target.value);

                                if (!isNaN(value) && value !== 0) {
                                    this.handleAmountChange(colorantPackage.key, Number(value));
                                } else {
                                    this.handleAmountChange(colorantPackage.key, -1);
                                }
                            }}
                            disabled={false}
                            extended={false}
                            setInputState={(value) => {
                                this.handleAmountChange(colorantPackage.key, Number(value));
                            }}
                            className={"width-100per text-center general-input primary-input"}
                        />
                    )
                ],
                this.state.flashingKey === colorantPackageKey ? "flash-background" : "",
                colorantPackageKey,
                {
                    onAnimationEnd: this.onAnimationEnd
                }
            );
        });
    };

    getColorantPackagesToAdd = () => {
        return (
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
            />
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("stock.addColorantPackagesToStock"))}
                subHeader={modelHelper.buildModalSection(
                    <React.Fragment>
                        <span className="glyphicon glyphicon-info-sign" />
                        &nbsp;
                        {translate("stock.scanBarcodeOrSelectColorant")}
                    </React.Fragment>
                )}
                content={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.getAddColorantPackageLine()}
                        {this.getColorantPackagesToAdd()}
                    </React.Fragment>,
                    "flex-column"
                )}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        <Button
                            className="flex-align-center min-width-150"
                            label={<Translate value="general.ok" />}
                            disabled={Object.keys(this.state.colorantPackagesToAdd).length === 0}
                            onClick={this.handleSubmit}
                        />
                        <CloseButton onClick={this.handleCloseModalClick} />
                    </React.Fragment>,
                    "flex-gap-10px"
                )}
                styles={{minWidth: "50%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        barcode: store.barcode.item,
        barcodeType: store.barcode.itemType,
        colorantPackages: store.stock.colorantPackages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseAddColorantPackagesToStockModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.ADD_COLORANT_PACKAGES_TO_STOCK_MODAL));
        },
        dispatchResetBarcodeAction: () => {
            dispatch(barcodeActions.resetBarcode());
        }
    };
};

export default AddColorantPackagesToStockModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(AddColorantPackagesToStockModal);
